export default __webpack_public_path__ + "21fbc7035cc1b13c2d0457f38d0cfd1d.webp";